import { useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import { WorksheetSchemaField } from '../../../../types/custom-worksheet-v2';
import { selectCurrentEditingField, selectShowHidden } from '../store/selectors';
import { calcLeftPadding } from '../utils';
import CompleteIndicator from '../CompleteIndicator';
import NavItem from './NavItem';

type FieldItemProps = {
    field: WorksheetSchemaField;
};

function FieldItem({ field }: FieldItemProps): JSX.Element {
    const currentEditingField = useSelector(selectCurrentEditingField);
    const showHidden = useSelector(selectShowHidden);
    const isEditing = currentEditingField === field.id;

    if (field.hidden && !showHidden) {
        return <></>;
    }
    return (
        <NavItem id={field.id}>
            <div
                className={`flex items-center group hover:bg-gray-50 pr-1 py-1 ${isEditing ? 'font-bold' : ''}`}
                style={{ paddingLeft: calcLeftPadding(field.id) }}
            >
                {isEditing && (
                    <motion.div
                        layoutId="tree-nav-editing-field"
                        className="bg-indigo-500 h-[22px] w-0.5 shrink-0 absolute left-0"
                    ></motion.div>
                )}
                <CompleteIndicator isCompleted={field.value !== null} />
                <p className="pl-2 text-sm text-gray-600 group-hover:text-indigo-600 ">{field.name}</p>
            </div>
        </NavItem>
    );
}

export default FieldItem;
